/* RESPONSIBLE TEAM: team-workflows */
import type RemoveConversationPriority from 'embercom/models/operator/visual-builder/step/remove-conversation-priority';
import StepConfig, { type StepConfigParams } from '../step';

export default class RemoveConversationPriorityConfiguration extends StepConfig {
  declare step: RemoveConversationPriority;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/remove-conversation-priority',
      ...params,
    });
  }
}
